import { fetchStatistics } from '../../../entities/statistics/registrations';

export const scope = 'STATISTICS_REGISTRATIONS';
export const REFRESH_STATS = 'REFRESH_STATS';

export function fetchStatsIfNeeded(payload) {
    return (dispatch, getState) => {
        const { registrations } = getState().app.statistics;

        if (!registrations.info.isFetching && registrations.info.needRefresh)
            dispatch(fetchStatistics(payload, scope));
    };
}

export function refreshStats(payload) {
    return (dispatch, getState) => {
        const { registrations } = getState().app.statistics;

        if (!registrations.info.isFetching)
            dispatch(fetchStatistics(payload || registrations.info.lastPayload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/monitoring/statistics/registrations.js